import './App.css';
import { useEffect, useState } from 'react';
import Header from './components/Header/Header';
import Main from './components/Main/Main';
import Footer from './components/Footer/Footer';
import LoadingScreen from './components/LoadingScreen/LoadingScreen';

function App() {
  const [mode, setMode] = useState("demo");
  const [currentDog, setCurrentDog] = useState(require("./media/Textures/Dogs/daisy.png"));
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const handleLoad = () => setLoading(false);

    if (document.readyState === 'complete') {
      setLoading(false);
    } else {
      window.addEventListener('load', handleLoad);
      return () => window.removeEventListener('load', handleLoad);
    }
  }, []);
  
  return (
    <div className="App">
      {loading && <LoadingScreen />}
      <div className="container">
        <Header mode={mode} setMode={setMode} currentDog={currentDog} setCurrentDog={setCurrentDog} />
        <Main mode={mode} currentDog={currentDog} />
      </div>
      <Footer/>
    </div>
  );
}

export default App;
